import { util } from '@glu/core';
import Marionette from 'backbone.marionette';

/**
 * Designed to inject the regions element reference into the view.  In this
 * manner there is no extra nesting within the region for the view.
 * This is necessary for a table layout that would forbid an immediate child of div
 * inside of a thead or tbody tag.
 */
export default Marionette.Region.extend({
  show(view, options) {
    this.ensureEl();
    const showOptions = options || {};
    const isViewClosed = view.isClosed || util.isUndefined(view.$el);
    const isDifferentView = view !== this.currentView;
    const preventClose = !!showOptions.preventClose;

    // only close the view if we don't want to preventClose and the view is different
    const shouldCloseView = !preventClose && isDifferentView;

    if (shouldCloseView) {
      this.close();
    }

    Marionette.triggerMethod.call(this, 'before:show', view);

    if (util.isFunction(view.triggerMethod)) {
      view.triggerMethod('before:show');
    } else {
      Marionette.triggerMethod.call(view, 'before:show');
    }

    if (isDifferentView || isViewClosed) {
      this.open(view);
    }

    view.render();

    this.currentView = view;

    Marionette.triggerMethod.call(this, 'show', view);

    if (util.isFunction(view.triggerMethod)) {
      view.triggerMethod('show');
    } else {
      Marionette.triggerMethod.call(view, 'show');
    }

    return this;
  },
  open(view) {
    this.$el.empty();
    view.setElement(this.$el);
  }
});
